var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "request-demo"
  }, [_c('div', {
    staticClass: "flex justify-between items-end mb-6 mdmax:flex-col mdmax:items-stretch gap-4"
  }, [_c('div', {
    staticClass: "flex-1 mdmax:w-full"
  }, [_c('div', {
    staticClass: "grid grid-cols-1 md:grid-cols-3 gap-4"
  }, [_c('div', [_c('label', {
    staticClass: "text-base text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Status")]), _c('v-select', {
    staticClass: "bg-white rounded-md",
    attrs: {
      "options": _vm.statusOptions,
      "reduce": function (option) {
        return option.value;
      },
      "label": "label",
      "placeholder": "Pilih Status"
    },
    model: {
      value: _vm.queries.status,
      callback: function ($$v) {
        _vm.$set(_vm.queries, "status", $$v);
      },
      expression: "queries.status"
    }
  })], 1), _c('div', [_c('label', {
    staticClass: "text-base text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Rentang Tanggal")]), _c('div', {
    staticClass: "date-range relative text-xs bg-white rounded-md"
  }, [_c('date-range-picker', {
    ref: "picker",
    attrs: {
      "locale-data": {
        format: 'dd/mm/yyyy',
        separator: ' - '
      },
      "showDropdowns": false,
      "timePicker": false,
      "timePicker24Hour": false,
      "ranges": false
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function (picker) {
        return [picker.startDate && picker.endDate ? _c('span', [_vm._v(" " + _vm._s(_vm._f("date")(picker.startDate)) + " - " + _vm._s(_vm._f("date")(picker.endDate)) + " ")]) : _c('span', {
          staticClass: "text-neutral-400"
        }, [_vm._v("Pilih Tanggal")])];
      }
    }]),
    model: {
      value: _vm.dateRange,
      callback: function ($$v) {
        _vm.dateRange = $$v;
      },
      expression: "dateRange"
    }
  }), _vm.dateRange.startDate && _vm.dateRange.endDate ? _c('div', {
    staticClass: "absolute right-2 top-1/2 transform -translate-y-1/2 cursor-pointer text-gray-400 hover:text-gray-600 z-10",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.clearDateLocal.apply(null, arguments);
      }
    }
  }, [_vm._v(" ✕ ")]) : _vm._e()], 1)]), _c('div', {
    staticClass: "flex items-center gap-3 pt-7"
  }, [_c('button', {
    staticClass: "px-4 py-2 bg-primary-500 text-white rounded-lg hover:bg-primary-600 font-medium whitespace-nowrap",
    on: {
      "click": _vm.applyFilter
    }
  }, [_vm._v(" Filter ")]), _vm.hasFilter ? _c('button', {
    staticClass: "px-4 py-2 border border-neutral-300 text-neutral-600 bg-white rounded-lg hover:bg-neutral-50 font-medium whitespace-nowrap",
    on: {
      "click": _vm.resetFilter
    }
  }, [_vm._v(" Reset Filter ")]) : _vm._e()])])])]), _c('TableComponent', {
    attrs: {
      "columns": _vm.columns,
      "list": _vm.requestDemos
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function (_ref) {
        var entry = _ref.entry,
            column = _ref.column;
        return [column.field === 'action' ? _c('span', {
          staticClass: "flex gap-2 justify-center"
        }, [_c('button', {
          staticClass: "p-2 rounded bg-neutral-100 text-neutral-600 hover:bg-neutral-200 focus:outline-none",
          attrs: {
            "title": "Detail Data"
          },
          on: {
            "click": function ($event) {
              return _vm.openDetailModal(entry);
            }
          }
        }, [_c('Eye', {
          staticClass: "w-4 h-4"
        })], 1), _c('button', {
          staticClass: "p-2 rounded bg-neutral-100 text-neutral-600 hover:bg-neutral-200 focus:outline-none",
          attrs: {
            "title": "Update Status"
          },
          on: {
            "click": function ($event) {
              return _vm.openUpdateModal(entry);
            }
          }
        }, [_c('Pencil', {
          staticClass: "w-4 h-4"
        })], 1)]) : column.field === 'status' ? _c('span', [_c('span', {
          staticClass: "px-2 py-1 rounded text-xs font-medium",
          class: _vm.statusClass(entry.status)
        }, [_vm._v(" " + _vm._s(_vm.getStatusLabel(entry.status)) + " ")])]) : column.field === 'created_at' ? _c('span', [_vm._v(" " + _vm._s(_vm.formatDate(entry.created_at)) + " ")]) : column.field === 'type' ? _c('span', [_vm._v(" " + _vm._s((entry[column.field] || '').toUpperCase()) + " ")]) : _c('span', {
          staticClass: "whitespace-nowrap"
        }, [_vm._v(_vm._s(entry[column.field] !== null && entry[column.field] !== undefined && entry[column.field] !== '' ? entry[column.field] : '-'))])];
      }
    }])
  }), _vm.requestDemos && _vm.requestDemos.length > 0 ? _c('div', {
    staticClass: "mt-6 mb-6 flex justify-between items-center mdmax:flex-col mdmax:items-start gap-4"
  }, [!_vm.isMobile ? _c('div', {
    staticClass: "text-sm font-medium text-neutral-500"
  }, [_vm._v(" Menampilkan " + _vm._s(_vm.start) + " - " + _vm._s(_vm.end) + " dari " + _vm._s(_vm.totalRecords) + " ")]) : _vm._e(), _c('pagination', {
    attrs: {
      "currentPage": _vm.queries.page,
      "totalCount": _vm.totalRecords,
      "pageSize": _vm.queries.per_page
    },
    on: {
      "onPageChange": _vm.onPageChange
    }
  })], 1) : _vm._e(), _c('Modal', {
    attrs: {
      "modalVisible": _vm.updateModalVisible,
      "width": "450px"
    },
    on: {
      "close": _vm.closeUpdateModal
    }
  }, [_c('div', {
    staticClass: "text-left",
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('h3', {
    staticClass: "text-lg font-bold text-neutral-800 mb-4"
  }, [_vm._v(" Update Status ")]), _c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "block text-sm font-medium text-neutral-700 mb-2"
  }, [_vm._v("Status")]), _c('v-select', {
    staticClass: "bg-white rounded-md w-full",
    attrs: {
      "options": _vm.statusOptions.filter(function (o) {
        return o.value !== '';
      }),
      "reduce": function (option) {
        return option.value;
      },
      "label": "label",
      "clearable": false
    },
    model: {
      value: _vm.updateForm.status,
      callback: function ($$v) {
        _vm.$set(_vm.updateForm, "status", $$v);
      },
      expression: "updateForm.status"
    }
  })], 1), _c('div', {
    staticClass: "flex justify-end gap-3"
  }, [_c('button', {
    staticClass: "px-4 py-2 rounded-lg border border-neutral-300 text-neutral-600 hover:bg-neutral-50 font-medium",
    on: {
      "click": _vm.closeUpdateModal
    }
  }, [_vm._v("Batal")]), _c('button', {
    staticClass: "px-4 py-2 rounded-lg bg-primary-500 text-white hover:bg-primary-600 font-medium flex items-center justify-center min-w-[100px]",
    attrs: {
      "disabled": _vm.isUpdating
    },
    on: {
      "click": _vm.submitUpdateStatus
    }
  }, [_vm.isUpdating ? _c('span', [_vm._v("Menyimpan...")]) : _c('span', [_vm._v("Simpan")])])])])]), _c('Modal', {
    attrs: {
      "modalVisible": _vm.detailModalVisible,
      "width": "500px"
    },
    on: {
      "close": _vm.closeDetailModal
    }
  }, [_c('div', {
    staticClass: "text-left",
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('h3', {
    staticClass: "text-lg font-bold text-neutral-800 mb-4 border-b pb-2"
  }, [_vm._v(" Detail Request Demo ")]), _vm.selectedDetail ? _c('div', {
    staticClass: "space-y-4 mb-6 text-sm text-neutral-700"
  }, [_c('div', {
    staticClass: "grid grid-cols-3 gap-2"
  }, [_c('div', {
    staticClass: "font-medium"
  }, [_vm._v("Nama PIC")]), _c('div', {
    staticClass: "col-span-2"
  }, [_vm._v(_vm._s(_vm.selectedDetail.pic_name || '-'))])]), _c('div', {
    staticClass: "grid grid-cols-3 gap-2"
  }, [_c('div', {
    staticClass: "font-medium"
  }, [_vm._v("Perusahaan")]), _c('div', {
    staticClass: "col-span-2"
  }, [_vm._v(_vm._s(_vm.selectedDetail.company || '-'))])]), _c('div', {
    staticClass: "grid grid-cols-3 gap-2"
  }, [_c('div', {
    staticClass: "font-medium"
  }, [_vm._v("Tipe")]), _c('div', {
    staticClass: "col-span-2"
  }, [_vm._v(_vm._s(_vm.selectedDetail.type ? _vm.selectedDetail.type.toUpperCase() : '-'))])]), _c('div', {
    staticClass: "grid grid-cols-3 gap-2"
  }, [_c('div', {
    staticClass: "font-medium"
  }, [_vm._v("No HP")]), _c('div', {
    staticClass: "col-span-2"
  }, [_vm._v(_vm._s(_vm.selectedDetail.phone_number || '-'))])]), _c('div', {
    staticClass: "grid grid-cols-3 gap-2"
  }, [_c('div', {
    staticClass: "font-medium"
  }, [_vm._v("Email")]), _c('div', {
    staticClass: "col-span-2 break-words whitespace-normal"
  }, [_vm._v(_vm._s(_vm.selectedDetail.email || '-'))])]), _c('div', {
    staticClass: "grid grid-cols-3 gap-2"
  }, [_c('div', {
    staticClass: "font-medium"
  }, [_vm._v("Alamat")]), _c('div', {
    staticClass: "col-span-2 break-words whitespace-normal"
  }, [_vm._v(_vm._s(_vm.selectedDetail.address || '-'))])]), _c('div', {
    staticClass: "grid grid-cols-3 gap-2"
  }, [_c('div', {
    staticClass: "font-medium"
  }, [_vm._v("Tanggal Dibuat")]), _c('div', {
    staticClass: "col-span-2"
  }, [_vm._v(_vm._s(_vm.formatDate(_vm.selectedDetail.created_at)))])]), _c('div', {
    staticClass: "grid grid-cols-3 gap-2"
  }, [_c('div', {
    staticClass: "font-medium"
  }, [_vm._v("Status")]), _c('div', {
    staticClass: "col-span-2"
  }, [_c('span', {
    staticClass: "px-2 py-1 rounded text-xs font-medium",
    class: _vm.statusClass(_vm.selectedDetail.status)
  }, [_vm._v(" " + _vm._s(_vm.getStatusLabel(_vm.selectedDetail.status)) + " ")])])])]) : _vm._e(), _c('div', {
    staticClass: "flex justify-end"
  }, [_c('button', {
    staticClass: "px-4 py-2 rounded-lg bg-neutral-200 text-neutral-700 hover:bg-neutral-300 font-medium",
    on: {
      "click": _vm.closeDetailModal
    }
  }, [_vm._v("Tutup")])])])])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }